module.exports = __webpack_public_path__ + "img/newPrincipal.e9bb89fb.jpeg";